import { useLocation } from "@reach/router";

export const useIsWinePage = (): boolean => {
  const location = useLocation();
  return (
    location.pathname.startsWith("/wines") ||
    location.pathname.startsWith("/offer-preview") ||
    location.pathname.startsWith("/event-preview")
  );
};

export const useCategoryNavivationPage = (): boolean => {
  const location = useLocation();
  return (
    location.pathname.startsWith("/wines") ||
    location.pathname.startsWith("/events") ||
    location.pathname.startsWith("/wine-clubs") ||
    location.pathname === "/"
  );
};
